import script from "./AtomTitleWelcome.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomTitleWelcome.vue?vue&type=script&lang=ts&setup=true"

import "./AtomTitleWelcome.vue?vue&type=style&index=0&id=ae4e900e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae4e900e"]])

export default __exports__